import {v4 as uuidv4} from "uuid";
import React, {useState} from "react";
import {dateConvert} from "../../Utils/ConvertDate";
import {titleCase} from "../../Users/addUser";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import {history} from "../../../Helpers/history";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Label from "../../Utils/FormInputs/Label";
import Col from "react-bootstrap/Col";
import {AutoCompleteProducts} from "../../Utils/FormInputs/AutoCompleteInput";
import TextField from "../../Utils/FormInputs/TextField";
import {ErrorMessage} from "../../Utils/styledComponents";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinus} from "@fortawesome/free-solid-svg-icons/faMinus";
import PrintDialog from "../../Utils/Dialogs/PrintDialog";
import {FullScreenDialog} from "../../Utils/Dialogs/FullScreenDialog";
import {useTheme} from "@material-ui/core/styles";

function MakeLabRequisition({openRequisition, setRequisition, setIsSubmitted, isSubmitted, actions}) {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const requested_by = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;
    const user_name = !_token.user_name ? "" : _token.user_name;
    const user_roles_id = !_token.user_roles_id ? 1 : _token.user_roles_id;

    const [products, setProducts] = useState([{
        product_name: '', product_id: '', available_quantity: 0, generic_name: '',
        quantity: '', showProduct: false, isError: false, uuid: uuidv4(), item_quantity: '0', system_stock: 0
    }]);
    const [items, setItems] = useState([]);
    const [state, setState] = useState({
        date_requested: dateConvert(), date_needed: '', contact: '',
        remarks: '', email: ''
    })
    const [requisition_id, setId] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [openDialog, setDialog] = useState(false)


    const retrieveProducts = (eventTxt, idx) => {

        const productCopy = [...products];

        if (productCopy[idx]) {
            productCopy[idx].product_name = eventTxt;
            const formData = new FormData();
            formData.append('product_name', titleCase(eventTxt));
            formData.append('to_store', 'Labs')
            if (eventTxt !== '') {
                axios.post(`${config.smsUrl}/cinventory/product_search_by_name`, formData).then(res => {
                    const resp = res.data;
                    const data = !resp ? [] : resp;
                    if (resp === "No Medicine Found") {
                        const val = [{value: "", label: "No Medicine Found"}]
                        setItems(val)
                    } else {
                        setItems(data);
                    }
                }).catch(error => {
                    logoutErrorMessage(error, null, actions)
                });
            }
            productCopy[idx].showProduct = true;
            productCopy[idx].isError = false;
        } else {
            productCopy[idx].isError = false;
            productCopy[idx].showProduct = false;
        }
        setProducts(productCopy)
    };

    const clickProduct = (event, idx) => {
        let arr = products.map((item, index) => {
            if (index === idx) {
                return {
                    ...item,
                    product_name: event.innerText,
                    product_id: event.value,
                    generic_name: event.generic_name
                }
            }
            return item
        })
        if (event.value) {
            const formData = new FormData();
            formData.append('product_id', event.value);
            formData.append('location', 1); // 1 for store
            formData.append('to_store', 'Labs')
            axios.post(`${config.smsUrl}/cdoctor/get_medicinedetails_byproduct_id`, formData).then(res => {
                const resp = res.data;
                const data = !resp ? {} : resp;
                arr = arr.map((item, index) => {
                    if (index === idx) {
                        return {
                            ...item,
                            available_quantity: data.stock,
                            category_name: data.category_name,
                            item_quantity: data.quantity ? data?.quantity?.toString() : '0',
                            system_stock: data.quantity ? data.quantity : 0
                        }
                    }
                    return item
                })
                setProducts(arr)
            }).catch(error => {
                logoutErrorMessage(error, null, actions)
            });
        }
    };

    const handleChangeItems = (event, index) => {
        const {value, name} = event.target;
        const arr = products.map((item, idx) => {
            if (index === idx) {
                return {...item, [name]: value}
            }
            return item
        })
        setProducts(arr)
    };


    const handleAddRow = () => {
        setProducts([...products, {
            product_name: '', product_id: '', available_quantity: '', generic_name: '',
            quantity: '', showProduct: false, isError: false, uuid: uuidv4(), item_quantity: '0', system_stock: 0
        }])
    };

    const removeRow = (item_uuid) => {
        const new_arr = products.filter(e => e.uuid !== item_uuid);
        setProducts(new_arr);
    };


    const handleCloseDialog = () => {
        setDialog(false)
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        const {remarks} = state;
        setSubmitted(true);
        const productIds = products.filter(drug => drug.product_id && drug.quantity);
        const arr = products.every(drug => drug.product_id && drug.quantity && drug.available_quantity !== 0)
        const isSundry = products.every(drug => (drug.category_name === "Sundries" && drug.item_quantity === '0') ||
            (drug.category_name !== "Sundries"))
        if (arr && isSundry) {
            setIsSubmitted('pending');
            const jsonData = {
                user_roles_id, from_department: 'Labs', store_id: 1,
                remarks, products: productIds.map(item => ({
                    product_id: item.product_id,
                    quantity: +item.quantity,
                    main_store_stock: +item.available_quantity,
                    depart_store_stock: item.system_stock,
                    physical_stock: +item.item_quantity

                }))
            }
            axios.post(`${config.smsUrl}/cinventory/make_requisition`, jsonData).then((res) => {
                const data = res.data;

                const dt = !data.data ? {} : data.data;
                const _id = !dt.requisition_id ? '' : dt.requisition_id;
                setId(_id)
                setDialog(true);
                actions.snackbarActions.snackSuccess('Requisition saved successfully');
                setIsSubmitted('resolved');
                const arr = products.map(item => ({
                    ...item, product_name: '', product_id: '', available_quantity: '',
                    quantity: '', showProduct: false, isError: false
                }))
                setProducts(arr)
                setSubmitted(false)
            }).catch(err => {
                setIsSubmitted('rejected');
                errorMessages(err, null, actions);
            })
        }
    };

    const handleClick = () => {
        history.push(`/viewrequisition/lab/${requisition_id}`)
    }

    const handleCancel = () => {
        setDialog(false)
        setProducts([{
            product_name: '', product_id: '', available_quantity: '',
            quantity: '', showProduct: false
        }]);
        setState({date_requested: dateConvert(), date_needed: '', contact: '', remarks: ''});
        setSubmitted(false)
    }

    const {date_requested} = state;
    const all_drugs = !items ? [] : items;

    const theme = useTheme();
    const them = !theme ? {} : theme;
    const palette = !them.palette ? {} : them.palette;

    const isPending = isSubmitted === 'pending'
    return (
        <FullScreenDialog open={openRequisition} handleClose={() => setRequisition(false)} title="Make Requisition">
            <PrintDialog openDialog={openDialog} handleClose={handleCloseDialog}
                         message="Print Requisition Note"
                         text="Would you like to print this requisition note" handleClick={handleClick}
                         handleCancel={handleCancel}/>
            <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                    <div className="col-lg-6">
                        <Form.Group as={Row}>
                            <Label name="Date Requested" htmlFor='date_requested' sm="3" column/>
                            <Col sm="6">
                                <Form.Control type="date" value={date_requested} disabled={true}
                                              className={`form__control ${palette.type === "dark" && 'form-control-dark'}`}
                                              id='date_requested'
                                              name="date_requested"/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Label name="Requested By" htmlFor='requestedby' sm="3" column/>
                            <Col sm="6">
                                <Form.Control type="text"
                                              className={`form__control ${palette.type === "dark" && 'form-control-dark'}`}
                                              name="requested_by" id='requestedby' value={requested_by}
                                              disabled={true}/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Label name="Email" htmlFor='email' sm="3" column/>
                            <Col sm="6">
                                <Form.Control type="email" value={user_name} disabled={true} id='email'
                                              className={`form__control ${palette.type === "dark" && 'form-control-dark'}`}
                                />
                            </Col>
                        </Form.Group>
                    </div>
                </div>
                <div className="table-responsive">
                    <table
                        className={`table table-sm table-bordered ${palette.type === 'dark' && 'dark-table dark-table-bordered'}`}>
                        <thead>
                        <tr>
                            <th className={palette.type === 'dark' && 'dark-theme-color'}>Particulars<span
                                className="help-block">*</span>
                            </th>
                            <th className={palette.type === 'dark' && 'dark-theme-color'}>Store Stock</th>
                            <th className={palette.type === 'dark' && 'dark-theme-color'}>Quantity<span
                                className="help-block">*</span>
                            </th>
                            <th className={palette.type === 'dark' && 'dark-theme-color'}>Available
                                Stock(Lab)
                            </th>
                            <th/>
                        </tr>
                        </thead>
                        <tbody>
                        {products.map((item, index) => {
                            const isSundries = item.category_name === "Sundries"
                            return (
                                <tr key={index} data-testid="drugs-row">
                                    <td>
                                        <AutoCompleteProducts options={all_drugs} submitted={submitted} idx={index}
                                                              handleChange={retrieveProducts}
                                                              medicine_value={{
                                                                  label: item.product_name,
                                                                  value: item.product_id,
                                                                  generic_name: item.generic_name
                                                              }}
                                                              id="test_name" name="drug_name"
                                                              errorMsg_Valid={"Please enter a valid product"}
                                                              valid_error_check={item.isError && submitted}
                                                              testId={`product_name-${index}`}
                                                              handleProductData={clickProduct}
                                                              placeholder="Type Product Name"
                                                              errorMsg="Please a select a valid product"/>

                                    </td>
                                    <td>
                                        {item.available_quantity}
                                    </td>
                                    <td>
                                        <TextField submitted={submitted} value={item.quantity} name="quantity"
                                                   onChange={(e) => handleChangeItems(e, index)} type="number"
                                                   data-testid={`quantity-${index}`} placeholder="Input quantity"/>
                                        {item.quantity && item.available_quantity === 0 ?
                                            <ErrorMessage>No stock available for this product</ErrorMessage> : null}
                                        {(submitted && !item.quantity) &&
                                            <ErrorMessage>Quantity is required</ErrorMessage>}
                                    </td>

                                    <td>
                                        {
                                            isSundries ?
                                                <>
                                                    <TextField submitted={submitted} value={item.item_quantity}
                                                               name="item_quantity"
                                                               onChange={(e) => handleChangeItems(e, index)}
                                                               type="number"
                                                               data-testid="item_quantity"
                                                               placeholder="Input quantity"/>
                                                    {(submitted && item.item_quantity !== '0') &&
                                                        <ErrorMessage>Quantity should be zero</ErrorMessage>}
                                                </> : item.item_quantity
                                        }

                                    </td>
                                    <td>
                                        <button onClick={() => removeRow(item.uuid)} type="button"
                                                className="btn btn-sm sms-btn-dismiss" data-testid="remove-row">
                                            <FontAwesomeIcon icon={faMinus}/>
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                        <tr>
                            <td colSpan={5}>
                                <button type="button" className="btn btn-sm sms-gray-btn" id="add-requisition-row"
                                        onClick={handleAddRow}>Add another line
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <button type="submit" disabled={isPending}
                        id="yesBtn" className="btn sms-btn btn-sm ">{isPending ? "Saving..." : "Save"}</button>
            </form>
        </FullScreenDialog>

    )
}

export default MakeLabRequisition